import { Component, OnInit } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { FilterHandlerService } from 'src/app/modules/core/services/filter/filter-handler.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { UserDataService } from 'src/app/modules/core/services/parameter';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportSpotConditionService } from '../../services/report-spot-condition.service';

@Component({
  selector: 'app-report-spot-condition',
  templateUrl: './report-spot-condition.component.html',
  styleUrls: ['./report-spot-condition.component.scss'],
})
export class ReportSpotConditionComponent implements OnInit {
  public tableConfig: ITableConfig;

  public params: any;

  public filterConfig: IFilterConfig;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private tableService: TableConfigService,
    private layoutConfigService: LayoutConfigService,
    private reportSpotService: ReportSpotConditionService,
    private userService: UserDataService,
    private langService: LanguageService,
    private datePipe: DatePresentationPipe,
    private filterHandlerService: FilterHandlerService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.filterConfig = { dates: {}, cleanButton: true };
    this.disabledExcelBtn = false;
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'spot conditions',
      imageKey: 'report',
      imageType: 'section',
    };
    this.layoutConfigService.setConfig(config);
  }

  /**
   * Function to get the filter data
   *
   * @param filters Output filters
   */
  public filterData(filters: IOutputFilter): void {
    this.filterConfig.isLoading = true;

    this.params = {
      startDate: filters.startDate,
      endDate: filters.endDate,
      companyId: this.userService.get().company.id,
    };

    this.getSpotCondition(this.params);
  }

  /**
   * Function to get spot condition data
   *
   * @param params Params to get the condition report
   */
  private async getSpotCondition(params: any): Promise<any> {
    try {
      await this.reportSpotService.getConditionReport(params).then(
        (report) => {
          for (const data of report.data) {
            data.hasExplosive = data.hasExplosive ? this.langService.message('yes') : this.langService.message('no');
          }

          this.setTableConfig(report.data);
          this.filterHandlerService.disabledFilterButton(false);
        },
        () => {},
      );
    } catch (e) {
      console.info(e);
    } finally {
      this.filterConfig.isLoading = false;
    }
    const filters = {
      reports: 'report-spot-condition',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * Map data for table
   *
   * @param tableData: Data of fronts.
   */
  private setTableConfig(tableData: any[]): void {
    const excludeColumns = ['conditionLogSyncId', 'zoneId', 'conditionId', 'conditionSourceId', 'explosiveCondition'];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      replaceColumnName: [{ prevName: 'operatorName', newName: 'operator-user' }],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
      dateConfig: [{ field: 'createdAt', format: 'date-time' }],
    };

    const { header, dataset } = this.tableService.setTableMainConfig(headerParams, datasetParams);
    this.tableConfig = { header, dataset };
  }

  /**
   * Function for excel exportation
   */
  public downloadExcel(): void {
    const selectRangeDate = {
      startDate: this.datePipe.transform(this.params.startDate),
      endDate: this.datePipe.transform(this.params.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportSpotService.getConditionReportExcel(this.params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'spot conditions', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
